import React from "react";
import _ from "lodash";
import Utils from "../../../../helpers/Utils";

const MedicalFillInFormPrint = ({ chartSideMedicalFillInForm }) => {
  const { printTemplates } = chartSideMedicalFillInForm;
  const templatesList = _.get(printTemplates, "templates", []);

  if (templatesList.length) {
    const cleanedHTML = Utils.cleanTableHTML(_.get(printTemplates, "vitalAnswerHtmlAsString", ""));

    return (
      <div className="pt-2">
        {templatesList.map((template, index) => (
          <div className="medical-fill-in-form-question" key={index}>
            <div
              className="medical-fill-in-form-question__body"
              dangerouslySetInnerHTML={{
                __html: _.get(template, "templateAnswerHtmlAsString", ""),
              }}
            />
          </div>
        ))}
        <div
          className="medical-fill-in-form-vital_table"
          dangerouslySetInnerHTML={{ __html: cleanedHTML }}
        />
      </div>
    );
  }
  return null;
};

export default MedicalFillInFormPrint;
